import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getMessageText = async (
  token: string,
  baseUrl: string,
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/message_text`;

    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
